module.exports = {
  init: () => {
    $(".actionbanner").each(function(i) {
      const banner = $(this);
      $(this)
        .find(".actionbanner-links-item")
        .on("click", function() {
          const source = $("#" + $(this).data("source"));
          const sourceText = source.html();
          const sourceBackground = source.data("background");

          $(".actionbanner-links-item").removeClass("actionbanner-links-item--active");
          $(this).addClass("actionbanner-links-item--active");
          $(banner)
            .find(".actionbanner-text > div")
            .html(sourceText);
          $(banner).css("background-image", "url(" + sourceBackground + ")");
          return false;
        });
    });
  }
};
